<script setup lang="ts">
  import { type HTMLAttributes, computed } from 'vue'
  import { AccordionContent, type AccordionContentProps } from 'radix-vue'
  import { cn } from '@/lib/utils'

  const props = defineProps<
    AccordionContentProps & { class?: HTMLAttributes['class']; overflow?: string }
  >()

  const delegatedProps = computed(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <AccordionContent
    class="text-sm transition-all data-[state=closed]:animate-accordion-up
      data-[state=open]:animate-accordion-down"
    v-bind="delegatedProps"
    :class="cn('overflow-hidden', `overflow-${props.overflow}`)"
  >
    <div :class="cn('pb-4 pt-0', props.class)">
      <slot />
    </div>
  </AccordionContent>
</template>
